import { GrowthBook } from '@growthbook/growthbook';
import { computed } from 'vue';
import store from '@/store';

// URL QUE VEM FLAGS HABILITADOS POR DEFAULT
const hasUrlFlag = ['develop.weon.com.br'];
// CONFIGURAÇÃO PARA HABILITAR TODAS AS FLAGS PARA TESTE, PARA DEPURAÇÃO COM BASE NO HASURLFLAG
const hostname = window.location?.hostname;
const isDev =
  process.env.NODE_ENV === 'development' || hasUrlFlag.includes(hostname);

const growthbook = new GrowthBook({
  apiHost: isDev ? 'https://cdn.growthbook.io' : 'https://cdn.growthbook.io',
  clientKey: isDev ? 'sdk-RxfCkpqTHQFrqP1' : 'sdk-rPbMpzbCBUFAEn0O',
  enableDevMode: isDev,
  trackingCallback: (experiment, result) => {
    // TODO: Use your real analytics tracking system
    console.log('Viewed Experiment', {
      experimentId: experiment.key,
      variationId: result.key,
    });
  },
});

// ========= STORE =========

const SET_FEATURE_FLAG = 'SET_FEATURE_FLAG';
const state = {
  flags: null,
};
const mutations = {
  [SET_FEATURE_FLAG](state, featureFlags) {
    state.flags = featureFlags;
  },
};

// Validação de flags
const flags = computed(() => store.state?.featureFlags?.flags);
/**
 *
 * @param {String *} flag
 * @param {String | Boolean | JSON | null} variation
 * @returns {String | Boolean}
 */
export const isFeatureEnabled = (flag, variation = null) => {
  if (!flag) return false;
  if (!flags.value || !flags.value[flag]) return false;
  if (variation !== null && flags.value[flag]?.defaultValue === variation)
    return true;
  return flags.value[flag]?.defaultValue;
};

// Executação de flags
class FeatureFlag {
  constructor() {
    if (FeatureFlag.instance) {
      return FeatureFlag.instance;
    }
    FeatureFlag.instance = this;
  }
  async init() {
    const { Attendance } = store.state?.attendance || {};
    await growthbook.init({ streaming: true, timeout: 2000 });
    growthbook.setAttributes({
      id: Attendance?.agentId,
      url: document.location.href,
      path: document.location.pathname,
      host: document.location.host,
    });
    this.setFeatureFlags();
    // Observa cada atualização de flag e atualiza o state da aplicação
    growthbook.setRenderer(() => {
      this.setFeatureFlags();
    });
  }

  setFeatureFlags() {
    let allFlags = localStorage.getItem('gbFeaturesCache') || null;
    if (typeof allFlags === 'string') allFlags = JSON.parse(allFlags);
    if (!allFlags || !allFlags[0]?.length) return;

    const {
      data: { features },
    } = allFlags[0][1];

    if (!Object.keys(features)) return;
    store.commit(`featureFlags/${SET_FEATURE_FLAG}`, features);
  }
}

export const featureFlagStore = {
  namespaced: true,
  state,
  mutations,
};

export default FeatureFlag;
